import { BaseWebComponentView } from '../../../framework/BaseWebComponentView';
import { HeaderMenuItem } from '../types';
import { GzHeaderUiWebComponent } from './GzHeaderUiWebComponent';

export class GzHeaderView extends BaseWebComponentView {
  getDomElements() {
    this.dom.$headerUi = this.shadow.querySelector('gz-header-ui') as GzHeaderUiWebComponent;
  }

  buildSuccessView(data: HeaderMenuItem[]) {
    this.dom.$headerUi.items = [...data];
  }
}
